import { render, staticRenderFns } from "./DuplicateIcon.vue?vue&type=template&id=2a74bb94&scoped=true&"
import script from "./DuplicateIcon.vue?vue&type=script&lang=js&"
export * from "./DuplicateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a74bb94",
  null
  
)

export default component.exports